import { Injectable } from '@angular/core';

export interface NetworkGraphState {
    entityId: string;
    partyId: string;
    highlightOption?: string;
    viewOption?: string;
    depthOption?: number;
}

@Injectable({
    providedIn: 'root',
})
export class NetworkGraphStateService {
    private storedState = new Map<string, NetworkGraphState>();

    createState(state: NetworkGraphState): NetworkGraphState {
        this.storedState.set(this.createKey(state), state);
        return state;
    }

    getState(entityId: string, partyId: string): NetworkGraphState | undefined {
        const key = this.createKey({ entityId, partyId });
        return this.storedState.get(key);
    }

    updateState(
        entityId: string,
        partyId: string,
        newState: Partial<NetworkGraphState>,
    ): NetworkGraphState | undefined {
        const key = this.createKey({ entityId, partyId });
        const currentState = this.storedState.get(key);
        if (!currentState) {
            return;
        }
        
        const updatedState = { ...currentState, ...newState };
        this.storedState.set(key, updatedState);
        return updatedState;
    }

    private createKey(state: NetworkGraphState) {
        return `${state.entityId}::${state.partyId}`;
    }
}
